import React, { useState, useEffect, useRef } from "react";

import { useDispatch, useSelector, shallowEqual } from "react-redux";

import {
  Table,
  Tooltip,
  Tag,
  Form,
  Input,
  Button,
  Space,
  Modal,
  Descriptions,
  Statistic,
  Col,
  Popconfirm,
  Collapse,
  Select,
  DatePicker,
  Divider,
  TimePicker,
  Checkbox,
  message,
} from "antd";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UserOutlined,
  VideoCameraOutlined,
  UploadOutlined,
  DeploymentUnitOutlined,
  SearchOutlined,
  EditOutlined,
  MinusCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";

import "./styles.scss";

import moment from "moment";

import {
  getData,
  editItem,
  addItem,
  deleteItem,
} from "../../../Redux/actions/crudActions";
import { errorParser } from "../../../utils/helpers";
import InputSelect from "../InputSelect";
// import EmailEditorField from '../EmailEditorField'
// import SiteEditorField from '../SiteEditorField'
import ImageField from "../ImageField";
import DateField from "../DateField";
import QuantityField from "../QuantityField";

const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const { Option } = Select;

const Index = ({
  currentItem,
  blueprint,
  token,
  saveForm,
  FormSubmitClick,
  FormOnChange,
}) => {
  const dispatch = useDispatch();
  const FormRef = useRef();
  const {
    orders,
    toPackOrders,
    toShipOrders,
    shippedOrders,
    cancelledOrders,
    googleSheetsInventoryData,
    gsheetLoading,
    gSheetsUpdateCount,
  } = useSelector((state) => ({}), shallowEqual);

  const [currentform] = Form.useForm();
  const [useThisItem, setUseThisItem] = useState(null);

  useEffect(() => {
    if (FormSubmitClick) {
      // give the Select component time to blur and fire onChange
      setTimeout(() => currentform.submit(), 50);
    }
  }, [FormSubmitClick]);

  useEffect(() => {
    if (currentItem) {
      setUseThisItem(currentItem);
    }
  }, [currentItem]);

  useEffect(() => {
    currentform.setFieldsValue({
      ...useThisItem,
    });
  }, [useThisItem]);

  const saveChanges = (form) => {
    var formData = {
      ...form,
    };
    blueprint.map((item) => {
      if (item.type == "fixed-value") {
        formData[item.key] = item.value;
      }
      if (item.type == "image") {
        if (typeof formData[item.key] == "string") {
          formData[item.key] = undefined;
        }
      }
      if (item.type == "options" || item.type == "options-multiple") {
        if (formData[item.key] == undefined) {
          if (item.type == "options") {
            formData[item.key] = null;
          }
          if (item.type == "options-multiple") {
            formData[item.key] = [];
          }
        }
      }
      if (item.type == "site-editor") {
        var newItem = formData[item.key];
        formData[item.key] = JSON.stringify(newItem.design);
        var newkey = item.key.split("_")[0] + "_content";
        formData[newkey] = newItem.html;
      }
      if (item.type == "date") {
        var newItem = formData[item.key];
        if (newItem) {
          if (newItem == "string") {
            formData[item.key] = undefined;
          } else {
            formData[item.key] = newItem.format("YYYY-MM-DD");
          }
        }
      }
    });

    Object.keys(formData).forEach((key) =>
      formData[key] === undefined ? delete formData[key] : {}
    );
    // console.log('formData',formData)
    saveForm(formData);
  };

  const disabledDate = (current) => {
    return current < moment().endOf("day");
  };

  const rulesReader = (schema) => {
    var rules = schema.rules;
    var rule = {};
    if (rules) {
      if (rules.required) {
        rule = {
          required: true,
          message: `please input ${schema.title}`,
        };
      }
      if (rules.type) {
        rule = {
          ...rule,
          type: rules.type,
        };
      }
      return [rule];
    } else {
      return [];
    }
  };

  const formextra = (index, value) => {
    console.log(index, value);
    currentform.setFieldsValue({
      [index]: value,
    });
  };

  const renderFormInput = (schema) => {
    // console.log(schema)

    switch (schema.type) {
      case "text":
        return (
          <Form.Item
            label={schema.title}
            name={schema.key}
            rules={rulesReader(schema)}
            className={"text"}
          >
            <Input />
          </Form.Item>
        );
      case "short_text":
        return (
          <Form.Item
            label={schema.title}
            name={schema.key}
            rules={rulesReader(schema)}
            className={"short_text"}
          >
            <Input />
          </Form.Item>
        );
      case "number":
        return (
          <Form.Item
            label={schema.title}
            name={schema.key}
            rules={rulesReader(schema)}
            className={"number"}
          >
            <Input type={"number"} suffix={schema.suffix} />
          </Form.Item>
        );

      case "quantity":
        return (
          <Form.Item
            label={schema.title}
            name={schema.key}
            rules={rulesReader(schema)}
            className={"number"}
          >
            <QuantityField currentProduct={schema.currentProduct} />
          </Form.Item>
        );
      case "text-area":
        return (
          <Form.Item
            label={schema.title}
            name={schema.key}
            rules={rulesReader(schema)}
            className={"textarea"}
          >
            <Input.TextArea />
          </Form.Item>
        );

      // case 'rich-text':
      //   return(
      //     <Form.Item
      //       label={schema.title}
      //       name={schema.key}
      //       rules={rulesReader(schema)}
      //       className={"textarea"}
      //       valuePropName={'value'}
      //     >
      //       <RichTextField />
      //     </Form.Item>
      //   )
      // case 'email-editor':
      //   return(
      //     <Form.Item
      //       label={schema.title}
      //       name={schema.key}
      //       rules={rulesReader(schema)}
      //       className={"textarea"}
      //       valuePropName={'value'}
      //     >
      //       <EmailEditorField token={token} currentItem={currentItem} />
      //     </Form.Item>
      //   )
      // case 'site-editor':
      //   return(
      //     <Form.Item
      //       label={schema.title}
      //       name={schema.key}
      //       rules={rulesReader(schema)}
      //       className={"textarea"}
      //       valuePropName={'value'}
      //     >
      //       <SiteEditorField token={token} currentItem={currentItem} schema={schema}/>
      //     </Form.Item>
      //   )

      case "boolean":
        return (
          <Form.Item
            label={schema.title}
            name={schema.key}
            valuePropName="checked"
            rules={rulesReader(schema)}
            className={"boolean"}
          >
            <Checkbox></Checkbox>
          </Form.Item>
        );
      case "image":
        return (
          <Form.Item
            label={schema.title}
            name={schema.key}
            rules={rulesReader(schema)}
            className={"textarea"}
          >
            <ImageField />
          </Form.Item>
        );
      case "options":
        return (
          <Form.Item
            label={schema.title}
            name={schema.key}
            rules={rulesReader(schema)}
            className={"options"}
          >
            <InputSelect
              blueprint={schema}
              mode={"options"}
              token={token}
              currentItem={useThisItem}
              onChangeName={(names) => {
                formextra(`${schema.key}_name`, names);
                console.log(names);
              }}
            />
          </Form.Item>
        );
      case "options-multiple":
        return (
          <Form.Item
            label={schema.title}
            name={schema.key}
            rules={rulesReader(schema)}
            className="options"
          >
            <InputSelect
              blueprint={schema}
              mode="options-multiple" // ← antd’s own mode
              token={token}
              currentItem={useThisItem}
              dropdownMatchSelectWidth={false}
              getPopupContainer={() => document.body}
              onChangeName={(names) => {
                formextra(`${schema.key}_name`, names);
              }}
            />
          </Form.Item>
        );
      case "fixed-options":
        return (
          <Form.Item
            label={schema.title}
            name={schema.key}
            rules={rulesReader(schema)}
            className={"options"}
          >
            <InputSelect
              blueprint={schema}
              mode={"fixed-options"}
              token={token}
              currentItem={useThisItem}
              onChangeName={(names) => {
                formextra(`${schema.key}_name`, names);
              }}
            />
          </Form.Item>
        );
      case "object-list":
        return (
          <Form.List
            label={schema.title}
            name={schema.key}
            rules={rulesReader(schema)}
            className={"options"}
          >
            {(fields, { add, remove }, { errors }) => (
              <>
                {fields.map((field, index) => (
                  <Form.Item
                    {...(index === 0
                      ? formItemLayoutList
                      : formItemLayoutWithOutLabelList)}
                    label={index < 1 ? schema.title : ""}
                    required={false}
                    key={field.key}
                    className={"options"}
                  >
                    <Form.Item
                      {...field}
                      validateTrigger={["onChange", "onBlur"]}
                      rules={[
                        {
                          required: true,
                          whitespace: true,
                          message: `Please input ${schema.title} or delete this field.`,
                        },
                      ]}
                      noStyle
                    >
                      <Input
                        placeholder={schema.title}
                        style={{ width: "75%" }}
                      />
                    </Form.Item>
                    {fields.length > 1 ? (
                      <MinusCircleOutlined
                        style={{ marginLeft: "1rem" }}
                        className="dynamic-delete-button"
                        onClick={() => remove(field.name)}
                      />
                    ) : null}
                  </Form.Item>
                ))}
                <Form.Item
                  {...(fields.length == 0 || fields.length == undefined
                    ? formItemLayoutList
                    : formItemLayoutWithOutLabelList)}
                  label={
                    fields.length == 0 || fields.length == undefined
                      ? schema.title
                      : ""
                  }
                  className={"options"}
                >
                  <Button
                    type="dashed"
                    onClick={() => add()}
                    style={{ width: "75%" }}
                    icon={<PlusOutlined />}
                  >
                    Add field
                  </Button>
                </Form.Item>
              </>
            )}
          </Form.List>
        );
      case "divider":
        return <Divider orientation="left">{schema.title}</Divider>;
      case "date":
        return (
          <Form.Item
            label={schema.title}
            name={schema.key}
            rules={rulesReader(schema)}
            className={"number"}
          >
            <DateField />
          </Form.Item>
        );
      case "hidden":
        return (
          <Form.Item
            label={schema.title}
            name={schema.key}
            rules={rulesReader(schema)}
            className={"hidden"}
          >
            <Input />
          </Form.Item>
        );

      default:
      // code block
    }
  };

  return (
    <Form
      ref={FormRef}
      form={currentform}
      layout={"middle"}
      className={"generic_form"}
      name="basic"
      initialValues={currentItem}
      onFinish={(e) => {
        saveChanges(e);
      }}
      onFinishFailed={(e) => {
        saveChanges(e);
      }}
      onValuesChange={(changedValues, allValues) => {
        console.log(allValues);
        if (FormOnChange) {
          FormOnChange(allValues);
        }
        // var item =Object.entries(changedValues)[0]
        // changeOrderData(item[0],item[1])
      }}
    >
      {blueprint.map((blue) => {
        return renderFormInput(blue);
      })}
    </Form>
  );
};

export default Index;
const formItemLayoutList = {
  labelCol: {
    xs: { span: 4 },
    sm: { span: 3 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 20 },
  },
};
const formItemLayoutWithOutLabelList = {
  wrapperCol: {
    xs: { span: 24, offset: 0 },
    sm: { span: 20, offset: 4 },
  },
};
